import { LottieAnimationData } from "@nvon/react-toolbox/dist/lib/components/NWONLottieWrapper/NWONLottieWrapperInterfaces";
import { StaticImageData } from "next/image";
import { ReactElement } from "react";

export enum MediaPosition {
  Left = "left",
  Right = "right",
}

export interface NWONTextWithImagesProps {
  illustration?: StaticImageData | ReactElement;
  animation?: LottieAnimationData;
  title: string;
  description: string;
  mediaPosition: MediaPosition;
}
